module.exports = __webpack_public_path__ + "img/home.2d8ee1b3.svg";